// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    'Deslocado ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '.',
  accButtonProgressComplete: (p: { label: string }) => 'Ação ' + p['label'] + ' concluída',
  accButtonProgressStatus: (p: { label: string }) => 'Ação ' + p['label'] + ' a decorrer',
  accColorPalette: () => 'Paleta de Cores',
  accColorSwatch: () => 'Coleção de Cores',
  accCommandKey: () => 'Comando',
  accContextMenuLabel: () => 'ações',
  accControlKey: () => 'Fechar',
  accPositionAfter: () => 'após',
  accPositionBefore: () => 'antes',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'Prima e mantenha premido ' +
    p['keyPressed'] +
    ' e Shift, em seguida, utilize as teclas de setas para reordenar.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Introduza uma data completa como esta: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Introduza o mês e ano da seguinte forma: ' + p['dateExample'] + '.',
  chart_labelDataLabel: () => 'Etiqueta',
  chart_labelGroup: () => 'Grupo',
  chart_labelSeries: () => 'Série',
  chart_labelValue: () => 'Valor',
  chart_labelWidthWeight: () => 'Z',
  chart_labelX: () => 'X',
  chart_labelY: () => 'Y',
  checkboxSet_requiredMessageDetail: () => 'Selecione um valor.',
  checkbox_helpForCheckbox: () => 'Auxílio da caixa de seleção',
  checkbox_requiredMessageDetail: () => 'Selecione um valor.',
  checkbox_selected: () => 'Caixa de seleção selecionada',
  checkbox_unselected: () => 'Caixa de seleção não selecionada',
  close: () => 'Fechar',
  collection_apply: () => 'Aplicar',
  collection_cancel: () => 'Cancelar',
  collection_loaded: () => 'Carregado',
  collection_loading: () => 'A Carregar',
  collection_noData: () => 'Não existem dados para apresentação.',
  collection_pixels: () => 'píxel',
  collection_resizeColumnDialog: () => 'Redimensionar coluna',
  collection_resizeColumnMenu: () => 'Redimensionar Coluna...',
  collection_resizeMessageDetail: (p: { MIN: string; MAX: string }) =>
    'Introduza um número entre ' + p['MIN'] + ' e ' + p['MAX'] + '.',
  collection_selectAllRows: () => 'Selecionar Todas as Linhas',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Selecionar linha ' + p['ROW_NAME'],
  collection_sortAscendingSubMenu: () => 'Ordem crescente',
  collection_sortColumnMenu: () => 'Ordenar Coluna',
  collection_sortDescendingSubMenu: () => 'Ordem decrescente',
  collection_sortDisabled: () => 'Não ordenável',
  collection_sortEnabled: () => 'Ordenável',
  collection_width: () => 'Largura',
  colorPicker_label: () => 'Seletor de Cores',
  confirmation: () => 'Confirmação',
  datePicker_currentDate: () => 'Data atual',
  datePicker_goToToday: () => 'Ir para hoje',
  datePicker_label: () => 'Seletor de Datas',
  datePicker_month: () => 'Mês',
  datePicker_months: () => 'Meses',
  datePicker_next: () => 'Seguinte',
  datePicker_nextDecade: () => 'Década seguinte',
  datePicker_nextMonth: () => 'Mês seguinte',
  datePicker_prev: () => 'Anterior',
  datePicker_prevDecade: () => 'Década anterior',
  datePicker_prevMonth: () => 'Mês anterior',
  datePicker_restricted: () => 'Restrito',
  datePicker_selected: () => 'Selecionado',
  datePicker_today: () => 'Hoje',
  datePicker_weekNum: (p: { NUM: string }) => 'Semana ' + p['NUM'],
  datePicker_weekNumColLabel: () => 'Número da Semana',
  datePicker_year: () => 'Ano',
  datePicker_years: () => 'Anos',
  diagram_promotedLink: () => '1 ligação',
  diagram_promotedLinkAriaDesc: () => 'Indireto',
  diagram_promotedLinks: (p: { num_links: string }) => p['num_links'] + ' ligações',
  error: () => 'Erro',
  expandableList_expandCollapseInstructionText: () =>
    'Utilize as teclas de seta para expandir e contrair',
  expandableList_groupCollapse: () => 'Contraído',
  expandableList_groupExpand: () => 'Expandido',
  filePicker_addFiles: () => 'Acrescentar Ficheiros',
  filePicker_dropzonePrimaryText: () => 'Arrastar e Largar',
  filePicker_dropzoneSecondaryText: () => 'Selecionar um ficheiro ou largar um aqui',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Selecionar ou largar ficheiros aqui',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Não é possível carregar ficheiros do tipo: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Carregue um ficheiro de cada vez',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Não é possível carregar ficheiros do tipo ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'desconhecido',
  formControl_clear: () => 'Limpar',
  formControl_day: () => 'Dia',
  formControl_empty_segment: () => 'Vazia',
  formControl_helpAvailable: () => 'Auxílio disponível',
  formControl_hide: () => 'Ocultar',
  formControl_hour: () => 'Hora',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Atingiu o limite de ' +
    ((
      {
        one: new Intl.NumberFormat('pt-PT').format(p['CHARACTER_LIMIT']) + ' carácter',
        many: new Intl.NumberFormat('pt-PT').format(p['CHARACTER_LIMIT']) + ' caracteres'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('pt-PT').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('pt-PT').format(p['CHARACTER_LIMIT']) + ' caracteres') +
    '.',
  formControl_loading: () => 'A Carregar',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'Pode introduzir até ' + p['MAX_LENGTH'] + ' caracteres.',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Comprimento máximo ' + p['MAX_LENGTH'] + ' excedido.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' caracteres em falta.',
  formControl_millisecond: () => 'Milésimo de Segundo',
  formControl_minute: () => 'Minuto',
  formControl_month: () => 'Mês',
  formControl_readOnly: () => 'Só de leitura',
  formControl_requiredMessageDetail: () => 'Introduza um valor.',
  formControl_second: () => 'Segundo',
  formControl_selectionExactMessageDetail: (p: { n: string }) =>
    'Selecione ' + p['n'] + ' valores.',
  formControl_selectionOverflowMessageDetail: (p: { max: string }) =>
    'Atingiu o limite de ' + p['max'] + ' seleções.',
  formControl_selectionRangeMessageDetail: (p: { min: string; max: string }) =>
    'Selecione valores entre ' + p['min'] + ' e ' + p['max'] + '.',
  formControl_selectionUnderflowMessageDetail: (p: { min: string }) =>
    'Selecione, pelo menos, ' + p['min'] + ' valores.',
  formControl_show: () => 'Mostrar',
  formControl_year: () => 'Ano',
  gantt_labelDate: () => 'Data',
  gantt_labelEnd: () => 'Fim',
  gantt_labelLabel: () => 'Etiqueta',
  gantt_labelRow: () => 'Linha',
  gantt_labelStart: () => 'Início',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nenhuma secção correspondente encontrada.',
  indexer_keyboardInstructionText: () => 'Prima Enter para selecionar o valor.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Entre ' + p['FROM_SECTION'] + ' e ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Toque duas vezes e mantenha o toque para entrar no modo de gestos, em seguida, arraste para cima ou para baixo para ajustar o valor.',
  info: () => 'Informações',
  inputColor_selectColor: () => 'Selecione a cor',
  inputDateMask_date_cleared: () => 'Data limpa',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Vazia',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'aaaa',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Introduza uma data igual ou anterior a ' + p['max'] + '.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Introduza uma data igual ou posterior a ' + p['min'] + '.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Introduza uma data disponível.',
  inputDatePicker_instruction: () => 'Prima Tab para aceder ao calendário.',
  inputDatePicker_selectDate: () => 'Selecionar uma data',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Introduza um mês e ano que se situem em ou antes de ' + p['max'] + '.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Introduza um mês e ano que se situem em ou depois de ' + p['min'] + '.',
  inputNumber_converterParseError: () => 'Introduza um número.',
  inputNumber_decrease: () => 'Diminuir',
  inputNumber_increase: () => 'Aumentar',
  inputPassword_hidden: () => 'Senha Oculta',
  inputPassword_hide: () => 'Ocultar Senha',
  inputPassword_show: () => 'Mostrar Senha',
  inputSensitiveText_hidden: () => 'Texto confidencial oculto',
  inputTimeMask_timeRangeOverflowMessageDetail: (p: { max: string }) =>
    'Introduza uma hora igual ou anterior a ' + p['max'] + '.',
  inputTimeMask_timeRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Introduza uma hora igual ou posterior a ' + p['min'] + '.',
  inputTimeMask_time_cleared: () => 'Hora da limpeza',
  labelNone: () => 'Nenhum',
  list_msgFetchCompleted: () => 'Carregado',
  list_msgFetchingData: () => 'A Carregar',
  list_suggestion: () => 'Sugestão',
  menu_stateLoading: () => 'A Carregar',
  messageToast_allMessagesClosed: () => 'Todas as mensagens de alerta foram fechadas.',
  message_close: () => 'Fechar',
  message_confirmation: () => 'Êxito',
  message_error: () => 'Erro',
  message_info: () => 'Informações',
  message_navigationFromMessagesRegion: () =>
    'A entrar na região de mensagens. Prima F6 para navegar.',
  message_navigationToMessagesRegion: () =>
    'A região das mensagens tem mensagens novas. Prima F6 para navegar.',
  message_navigationToTouch: () => 'A região de mensagens tem novas mensagens.',
  message_warning: () => 'Aviso',
  noData_message: () => 'Não existem itens para apresentação',
  overflowItemLabel: () => 'Mais Separadores',
  plural_separator: () => ', ',
  popup_close_skipLink: () => 'Toque duas vezes para fechar a janela sobreposta aberta.',
  popup_liveRegion_F6_initial_focus_firstFocusable: () =>
    'A entrar na janela sobreposta. Prima F6 para navegar entre a janela sobreposta e o controlo associado.',
  popup_liveRegion_F6_initial_focus_none: () =>
    'Janela sobreposta aberta. Prima F6 para navegar entre a janela sobreposta e o controlo associado.',
  progressIndeterminate: () => 'A Decorrer',
  radioButton_checked: () => 'Botão de rádio selecionado',
  radioButton_selected: () => 'Botão de rádio selecionado',
  radioButton_unchecked: () => 'Botão de rádio não selecionado',
  radioButton_unselected: () => 'Botão de rádio não selecionado',
  radio_helpForRadio: () => 'Auxílio do botão de rádio',
  radio_requiredMessageDetail: () => 'Selecione um valor.',
  selectMultiple_apply: () => 'Aplicar',
  selectMultiple_back: () => 'Retroceder',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'Utilize as teclas de seta para a esquerda e direita para realçar os valores selecionados.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Prima a tecla de retrocesso ou a tecla Delete para retirar o valor selecionado.',
  selectMultiple_selectedValues: () => 'Valores selecionados',
  selectMultiple_showSelectedValues: () => 'Mostrar só valores selecionados.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' valores selecionados.',
  select_addToList: () => 'Acrescentar à lista',
  select_addToListAvailable: () => 'Acrescentar à lista disponível',
  select_closeDropdown: () => 'Prima Escape para fechar.',
  select_moreSearchOptions: () => 'Mais opções de pesquisa',
  select_moreSearchOptionsAvailable: () => 'Mais opções de pesquisa disponíveis',
  select_noMatchesFound: () => 'Não foram encontradas correspondências.',
  select_oneMatchFound: () => 'Foi encontrada uma correspondência',
  select_requiredMessageDetail: () => 'Selecione um valor.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' correspondências encontradas',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' ou mais correspondências encontradas',
  selectorAll_deselectAll: () => 'Anular a seleção de todos',
  selectorAll_selectAll: () => 'Selecionar todos',
  selector_selected: () => 'Caixa de seleção selecionada',
  selector_unselected: () => 'Caixa de seleção não selecionada',
  sheet_close: () => 'Fechar',
  switch_off: () => 'Desativado',
  switch_on: () => 'Ativado',
  tabBarNavigationList_removeCueText: () => 'Retirável',
  tabBar_tabContainsErrors: () => 'Contém erros',
  tabbar_accAnnounceRemovedKey: (p: { itemKey: string }) => p['itemKey'] + ' retirado(a)',
  tabbar_labelContextMenu: () => 'tem menu de contexto',
  tabbar_labelMoveLeft: () => 'Deslocar para a Esquerda',
  tabbar_labelMoveRight: () => 'Deslocar para a Direita',
  tabbar_labelRemove: () => 'Retirar',
  timeComponent_tooltipZoomIn: () => 'Aproximar',
  timeComponent_tooltipZoomOut: () => 'Afastar',
  timeConverter_parseError: () => 'Introduza uma hora de conclusão.',
  train_current: () => 'Atual',
  train_message_type: () => 'Tipo de Mensagem',
  train_not_visited: () => 'Não visitado',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Passo ' + p['currentStep'] + ' de ' + p['numberOfSteps'],
  train_visited: () => 'Visitado',
  userAssistance_learnMore: () => 'Mais informações',
  userAssistance_required: () => 'Obrigatório',
  vis_clearSelection: () => 'Limpar Seleção',
  vis_drillable: () => 'Passível de definir o nível de detalhe',
  vis_invalidData: () => 'Dados inválidos',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' de ' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'Seleção através de retângulo',
  vis_marqueeZoomTooltip: () => 'Zoom através de retângulo',
  vis_noData: () => 'Não existem dados para apresentação',
  vis_panTooltip: () => 'Deslocamento',
  vis_stateCollapsed: () => 'Contraído',
  vis_stateExpanded: () => 'Expandido',
  vis_stateLoaded: () => 'Carregado',
  vis_stateLoading: () => 'A Carregar',
  vis_stateSelected: () => 'Selecionado',
  vis_stateUnselected: () => 'Não selecionado',
  warn: () => 'Aviso'
};
export default bundle;
